import { Link } from "react-router-dom"
import { format } from "date-fns"


export default function InDocumentCard({_id, id, numberDocument, client_id, dateReception, numberDocOut, numberDocOutId}){
    return (
        <div>
            <div className="flex border-b border-slate-500">
                <Link to={`/inDocument/${id}`}>
                    <div className='flex flex-row font-bold text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400'>
                <div className="text-center w-16">
                    {numberDocument}
                </div>
                <div className="w-72">
                    {client_id}
                </div>
                <div className="text-center w-28">
                    {dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}
                </div>
                </div>
                </Link>
                <Link to={`/documentos/${numberDocOutId}`}>
                <div className="text-center w-20 font-bold text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400">
                    {numberDocOut}
                </div>
                </Link>
            </div>
        </div>
    )
}